import React from 'react';
import { motion } from 'framer-motion';
const drains = ['tu energía,', 'tu autoestima,', 'tu tranquilidad,', 'tus relaciones,', 'tu enfoque,', 'y hasta tu conexión espiritual.'];
export function DrainList() {
  return <section className="py-24 px-6" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-8 leading-tight text-cream" data-id="element-37">
            El apego emocional no solo afecta tu corazón…
          </h2>
          <p className="text-xl text-cream/70 mb-12" data-id="element-38">
            También comienza a drenar:
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4 mb-20" data-id="element-39">
          {drains.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="px-6 py-3 rounded-full bg-teal-900 border border-terracotta/30 text-cream text-lg shadow-sm" data-id="element-40">
              {item}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-41">
          <p className="text-lg text-cream/70 mb-12" data-id="element-42">
            Y mientras más intentas llenar ese vacío con otra persona…
            <br data-id="element-43" />
            <span className="font-medium text-cream" data-id="element-44">
              más te desconectas de ti.
            </span>
          </p>

          <div className="relative p-8 md:p-12 bg-teal-900 rounded-3xl shadow-sm border border-cream/10" data-id="element-45">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 text-6xl text-terracotta/30 font-serif" data-id="element-46">
              "
            </div>
            <h3 className="text-2xl md:text-3xl font-serif leading-relaxed text-cream" data-id="element-47">
              Muchas personas no están sufriendo por amor…
              <br data-id="element-48" />
              <span className="italic text-terracotta mt-2 block" data-id="element-49">
                están sufriendo por dependencia emocional.
              </span>
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}